import React, { FunctionComponent } from 'react';
import { BeatLoader } from 'react-spinners';
import { useAsync } from 'react-use';
import { getSimilarPurchases } from '../api.js';
import { SimilarPurchase } from './SimilarPurchase.js';
import styles from './SimilarPurchases.module.scss';
import { AdvertisementBlockProps } from './SimilarPurchases.type.js';

export const SimilarPurchases: FunctionComponent<AdvertisementBlockProps> = ({
  announceId,
}) => {
  const { loading, value: similarPurchasesRes } = useAsync(async () => {
    return await getSimilarPurchases({ announceId: String(announceId) });
  }, [announceId]);

  if (!similarPurchasesRes) {
    return loading ? (
      <div className={styles.loader}>
        <BeatLoader color="#2d9cdb" />
      </div>
    ) : null;
  }

  const { similarPurchases } = similarPurchasesRes;

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>С этими закупками смотрят</h2>
      <div className={styles.itemList}>
        {similarPurchases.map((similarPurchase) => {
          return (
            <SimilarPurchase
              key={similarPurchase.id}
              purchase={similarPurchase}
            />
          );
        })}
      </div>
    </div>
  );
};
